












import { Vue, Component } from 'vue-property-decorator'

const list = [
  {
    name: '0',
    label: '',
    subtit: '视频播放次数',
    icon: require('@/assets/image/icon-bofang.png'),
  },
  // {
  //   name: '0',
  //   label: '专栏阅读',
  //   icon: require('@/assets/image/bg-reader.png'),
  // },
  // {
  //   name: '0',
  //   label: '粉丝',
  //   icon: require('@/assets/image/bg-fans.png'),
  // },
  {
    name: '0',
    label: '',
    subtit: '累计点赞数',
    icon: require('@/assets/image/icon-zan.png'),
  },
  {
    name: '0',
    label: '',
    subtit: '视频收藏数',
    icon: require('@/assets/image/icon-shoucang.png'),
  },
  {
    name: '0',
    label: '',
    subtit: '累计订阅数',
    icon: require('@/assets/image/icon-dingyue.png'),
  },
  // {
  //   name: '0',
  //   label: '评论',
  //   icon: require('@/assets/image/bg-comment.png'),
  // },
]

@Component
export default class DataPreview extends Vue {
  // list: any = list

  // eslint-disable-next-line complexity
  get list() {
    if (!this.hasFetchUserInfo) return list
    const userInfo = this.userInfoNum
    const unit = 10000

    return [
      Object.assign({}, list[0], {
        name:
          userInfo.total_vv < unit
            ? userInfo.total_vv
            : (userInfo.total_vv / unit).toFixed(2),
        label: `${userInfo.total_vv < unit ? '' : '万'}`,
      }),

      Object.assign({}, list[1], {
        name:
          userInfo.total_like < unit
            ? userInfo.total_like
            : (userInfo.total_like / unit).toFixed(2),
        label: `${userInfo.total_like < unit ? '' : '万'}`,
      }),

      Object.assign({}, list[2], {
        name:
          userInfo.total_collect < unit
            ? userInfo.total_collect
            : (userInfo.total_collect / unit).toFixed(2),
        label: `${userInfo.total_collect < unit ? '' : '万'}`,
      }),

      Object.assign({}, list[3], {
        name:
          userInfo.total_fans < unit
            ? userInfo.total_fans
            : (userInfo.total_fans / unit).toFixed(2),
        label: `${userInfo.total_fans < unit ? '' : '万'}`,
      }),

      // Object.assign({}, list[1], {
      //   name:
      //     userInfo.totalVv < unit
      //       ? userInfo.totalVv
      //       : (userInfo.totalVv / unit).toFixed(2),
      //   label: `${userInfo.totalVv < unit ? '' : '万'}专栏阅读`,
      // }),

      // Object.assign({}, list[2], {
      //   name:
      //     userInfo.fansNum < unit
      //       ? userInfo.fansNum
      //       : (userInfo.fansNum / unit).toFixed(2),
      //   label: `${userInfo.fansNum < unit ? '' : '万'}粉丝`,
      // }),

      // Object.assign({}, list[3], {
      //   name:
      //     userInfo.total_like < unit
      //       ? userInfo.total_like
      //       : (userInfo.total_like / unit).toFixed(2),
      //   label: `${userInfo.total_like < unit ? '' : '万'}赞`,
      // }),

      // Object.assign({}, list[4], {
      //   name:
      //     userInfo.commentNum < unit
      //       ? userInfo.commentNum
      //       : (userInfo.commentNum / unit).toFixed(2),
      //   label: `${userInfo.commentNum < unit ? '' : '万'}评论`,
      // }),
    ]
  }

  // get userInfo() {
  //   return this.$store.state.userInfo
  // }

  get userInfoNum() {
    return this.$store.state.userInfoNum
  }

  get hasFetchUserInfo() {
    return this.$store.getters.hasFetchUserInfo
  }
}
